import { usePDPStructuredMarkup } from '@/scopes/products/pages/components/StructuredMarkup/hooks'

/**
 * Renders JSON-LD structured data for the PDP page.
 *
 * The <script type="application/ld+json"> tag is valid anywhere in the document (head or body).
 * We render it directly instead of using next/head to avoid client-side <head> DOM manipulation
 * that can interfere with other scripts (e.g. GTM) during hydration.
 *
 * @see https://nextjs.org/docs/app/guides/json-ld
 * @see https://developers.google.com/search/docs/appearance/structured-data/intro-structured-data#supported-formats
 */
export function StructuredMarkup() {
  const jsonLd = usePDPStructuredMarkup()

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jsonLd).replace(/</g, '\\u003c'),
      }}
    />
  )
}
